import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  w100: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  root: {
    backgroundColor: "#f8f8f8",
    [theme.breakpoints.down("575")]: {
      "& .buttons-container-responsive": {
        width: "auto",
        "& .row-responsive": {
          justifyContent: "space-around",
          "& button": {
            width: 200,
          },
        },
      },
    },
    [theme.breakpoints.down("430")]: {
      "& .buttons-container-responsive": {
        "& .row-responsive": {
          "& button": {
            width: 155,
          },
        },
      },
    },
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    // alignItems:'center',
    [theme.breakpoints.down("991")]: {
      display: "block",
      textAlign: "center",
      justifyContent: "center",
      "& .buttons-container-responsive": {
        width: "auto",
        // display:'flex',
        // justifyContent:"center",
      },
    },
  },
  pageTextArea: {
    [theme.breakpoints.down("991")]: {
      marginBottom: 10,
    },
  },
  pageTitle: {
    color: "#202020",
    fontSize: "32px",
    fontWeight: "bold",
    lineHeight: "44px",
  },
  pageDescription: {
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "30px",
    color: "#222429",
    marginTop: "20px",
    [theme.breakpoints.down("575")]: {
      display: "none",
    },
  },
  spinnerWrapper: {
    height: "500px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("767")]: {
      height: "250px",
    },
  },
  giftCardsRow: {
    display: "grid",
    overflow: "hidden",
    transition: "height 600ms",
    gridTemplateColumns: "repeat(4,1fr)",
    justifyContent: "flex-start",
    gap: "40px",
    gridAutoFlow: "dense",
    marginTop: "20px",
    width: "100%",
    "& .gift-card-item-detail-row": {
      flexWrap: "wrap",
      padding: "42px 28px 47px",
      [theme.breakpoints.down("991")]: {
        padding: "25px 28px 25px",
      },
      [theme.breakpoints.down("767")]: {
        height: "auto",
        padding: "25px 0px 25px",
      },
    },
    [theme.breakpoints.down("1190")]: {
      gridTemplateColumns: "repeat(4,1fr)",
    },
    [theme.breakpoints.down("1100")]: {
      justifyContent: "flex-start",
      gap: "20px",
    },
    [theme.breakpoints.down("991")]: {
      gridTemplateColumns: "repeat(3,1fr)",
      justifyContent: "space-around",
    },
    [theme.breakpoints.down("767")]: {
      justifyContent: "space-around",
      marginTop: 10,
    },
    [theme.breakpoints.down("720")]: {
      gridTemplateColumns: "repeat(3,1fr)",
    },
    [theme.breakpoints.down("575")]: {
      gridTemplateColumns: "repeat(2,1fr)",
    },
    [theme.breakpoints.down("430")]: {
      gridTemplateColumns: "repeat(2,1fr)",
    },
  },
  dividerStyles: {
    marginTop: "8px!important",
    background: "#245fad",
  },
  portraitItem: {
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
    background: "#FFFFFF",
    margin: "0 12px",
    padding: "10px",
    marginBottom: "30px",
    height: "277px",
    width: "95%",
    maxWidth: "100%",
    transition: "0.3s",
    "&.active": {
      border: "2.73px solid #245fad",
    },
    "&:hover": {
      boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.3)",
    },
  },
  landscapeItem: {
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
    background: "#FFFFFF",
    margin: "0 12px",
    padding: "10px",
    height: "167px",
    marginBottom: "30px",
    boxSizing: "border-box",
    border: "2px solid transparent",
    width: "95%",
    maxWidth: "100%",
    transition: "0.3s",
    "&.active": {
      border: "2.73px solid #245fad",
    },
    "&:hover": {
      boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.3)",
    },
  },
  itemDetailWrapper: {
    gridColumn: "1 / -1",
    width: "99%",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
    borderRadius: "10px",
    background: "#FFFFFF",
    margin: "0 12px 60px 12px",
    height: "415px",
  },
  itemDetailRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
  },
  imgArea: {
    width: "50%",
    textAlign: "center",
    "& img": {
      maxHeight: "339px",
      maxWidth: "339px",
      objectFit: "contain",
    },
  },
  textArea: {
    width: "50%",
    paddingLeft: "13%",
  },
  itemTitle: {
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "33px",
    color: "#202020",
  },
  itemPrice: {
    "& span:not(.value)": {
      fontSize: "20px",
      lineHeight: "27px",
      fontWeight: "bold",
      color: "#202020",
    },
    "& .value": {
      fontSize: "23px",
      lineHeight: "31px",
      fontWeight: "bold",
      color: "#202020",
    },
  },
  buttonsArea: {
    marginTop: "59px",
    marginLeft: "auto",
  },
}));

export default useStyles;
